import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type TPatientStatusBadgeVariant = 'prisoner' | 'violence';

@Component({
  selector: 'app-patient-status-badge',
  templateUrl: './patient-status-badge.component.html',
  styleUrls: ['./patient-status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientStatusBadgeComponent {
  @Input() label: string;
  @Input() variant: TPatientStatusBadgeVariant;
}
